<template>
    <SidePanel :title="$t('location-wiki')">
        <LocationHierarchyListTab />
    </SidePanel>
</template>

<script setup lang="ts">
import SidePanel from '@/components/SidePanel.vue';
import LocationHierarchyListTab from './LocationHierarchyListTab.vue';
</script>
